import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useMemo, useState } from "react";
import { useDebounce, useMerchantApiQuery } from "../hooks";

import {
  IRemoteDataContext,
  IViewDeveloperSettings,
} from "../interfaces-and-types";
import { DeveloperSettingsContext } from "./DeveloperSettingsContext";

export function DeveloperSettingsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const queryClient = useQueryClient();
  const [isRefreshing, setIsRefreshing] = useState<boolean>(true);
  const debouncePeriodElapsed = useDebounce(100, isRefreshing);

  const { isSuccess, isError, isLoading, data } =
    useMerchantApiQuery<IViewDeveloperSettings>("getDeveloperSettings", {
      enabled: debouncePeriodElapsed,
    });

  useEffect(() => {
    if (isRefreshing) {
      queryClient.refetchQueries(["getDeveloperSettings"]);

      setIsRefreshing(false);
    }
  }, [isRefreshing]);

  const refreshRemoteData = () => {
    setIsRefreshing(true);
  };

  // const is_live = data?.is_live || false;

  // const memoedDeveloperSettingsContext = useMemo(() => {
  const unMemoedDeveloperSettingsContext: IRemoteDataContext<IViewDeveloperSettings | null> =
    {
      isSuccess,
      isError,
      isLoading,
      data: data || null,
      refreshRemoteData,
    };

  //   return unMemoedDeveloperSettingsContext;
  // }, [isLoadingDeveloperSettings, isRefreshing, is_live]);

  return (
    <DeveloperSettingsContext.Provider value={unMemoedDeveloperSettingsContext}>
      {children}
    </DeveloperSettingsContext.Provider>
  );
}
